<div class="footer">
  <div><strong>Akshayam Organics</strong> &copy; 2016</div>
</div>
